import React from 'react';

import kebabCase from 'lodash/kebabCase';

import { Button, Link, Text } from '@change/ds-core-ui';
import { Checkbox } from '@change/ds-forms';

import type { TaskShape } from '../../../../types';

import { completedTaskStyles } from './CompletedTask.styles';

// TODO: might need to clean up props type for icon
type CompletedTaskProps = Omit<TaskShape, 'status' | 'isFirstActive'>;
export function CompletedTask({
	name,
	title,
	description,
	primaryActionText,
	primaryActionHref,
	primaryActionOnClick,
	showActionButton = true,
}: CompletedTaskProps): React.JSX.Element {
	const styles = completedTaskStyles();

	const textContent = (
		<>
			<Text
				data-qa={`task-title-${kebabCase(name)}`}
				variant="body"
				className="text-size-body-bold text-typography-weak line-through"
				as="p"
			>
				{title}
			</Text>
			<Text
				data-qa={`task-description-${kebabCase(name)}`}
				variant="body"
				size="small"
				className="text-typography-weak line-through"
				as="p"
			>
				{description}
			</Text>
		</>
	);

	return (
		<div>
			<div data-qa="petition-task" className="flex flex-col justify-between gap-4 py-5 md:flex-row md:gap-5">
				<div className={styles.checkboxWrapper()}>
					<Checkbox name={`task-checkbox-${kebabCase(name)}`} isSelected isReadOnly aria-label={title} />
					{primaryActionHref ? (
						<Link
							href={primaryActionHref}
							onClick={primaryActionOnClick}
							data-qa={`task-text-link-${kebabCase(name)}`}
							className="flex-1 text-left"
						>
							{textContent}
						</Link>
					) : (
						<button
							type="button"
							onClick={primaryActionOnClick}
							data-qa={`task-text-button-${kebabCase(name)}`}
							className="flex-1 text-left"
						>
							{textContent}
						</button>
					)}
				</div>
				{showActionButton && (
					<div className="hidden flex-col items-start gap-6 opacity-0 transition-opacity duration-200 group-hover:opacity-100 md:flex-row md:items-center lg:flex lg:w-40">
						{primaryActionHref ? (
							<Button
								as="a"
								variant="secondary"
								size="x-small"
								href={primaryActionHref}
								onClick={primaryActionOnClick}
								data-qa={`task-action-button-${kebabCase(name)}`}
								className="w-full bg-fill-inverse-strong md:w-40"
							>
								{primaryActionText}
							</Button>
						) : (
							<Button
								variant="secondary"
								size="x-small"
								onClick={primaryActionOnClick}
								data-qa={`task-action-button-${kebabCase(name)}`}
								className="w-full bg-fill-inverse-strong md:w-40"
							>
								{primaryActionText}
							</Button>
						)}
					</div>
				)}
			</div>
		</div>
	);
}
